import { GridReducer } from '../common/grid/grid.reducer';
import merge from 'lodash/merge';
import set from 'lodash/set';
import includes from 'lodash/includes';

/**
 * @function administrationAccountsRoomsReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function administrationAccountsRoomsReducer(state, action) {

    if (typeof state === 'undefined') {
        return {
            administrationAccountsRoomsGrid: merge(GridReducer(), {
                filter: {uuid: null}
            }),
            administrationAccountsRoom: {
                title: 'New Room',
                roomTypes: [],
                data: {
                    uuid: null,
                    accountId: null,
                    parentUuid: null,
                    name: null,
                    building: null,
                    level: null,
                    number: null,
                    created: null,
                    roomType: 37,
                    isWarningSignsPresent: null,
                    isRsoInfoDisplayed: null
                }
            },
            administrationAccountsRoomDocumentsGrid: merge(set(GridReducer(), 'itemsCount', undefined), {
                filter: {
                    uuid: null,
                    docType: null
                }
            }),
            administrationAccountsRoomDocument: {
                docTypes: [],
                id: null,
                docType: null,
                docNum: null,
                dueDate: null,
                filePath: null,
                room: null,
            }
        };
    }

    switch (action.type) {
        case 'ROOM_FETCH':
            if (action.id === 'administrationAccountsRoom') {
                return Object.assign({}, state, {
                    administrationAccountsRoom: Object.assign({}, state.administrationAccountsRoom, {
                        title: 'Room Data',
                        data: {
                            uuid: action.data.uuid,
                            accountId: action.data.accountId,
                            parentUuid: action.data.parentUuid,
                            name: action.data.name,
                            building: action.data.building,
                            level: action.data.level,
                            number: action.data.number,
                            created: action.data.created,
                            roomType: action.data.roomType,
                            isWarningSignsPresent: action.data.isWarningSignsPresent,
                            isRsoInfoDisplayed: action.data.isRsoInfoDisplayed
                        }
                    })
                });
            }
        case 'ROOM_RESET':
            if (action.id === 'administrationAccountsRoom') {
                return Object.assign({}, state, {
                    administrationAccountsRoom: Object.assign({}, state.administrationAccountsRoom, {
                        title: 'New Room',
                        data: {
                            uuid: null,
                            accountId: null,
                            parentUuid: null,
                            name: null,
                            building: null,
                            level: null,
                            number: null,
                            created: null,
                            roomType: 37,
                            isWarningSignsPresent: null,
                            isRsoInfoDisplayed: null
                        }
                    })
                });
            }
        case 'LOCATION_SELECTED':
            if (action.id === 'administrationAccountsRoomsGrid') {
                return Object.assign({}, state, {
                    administrationAccountsRoomsGrid: set(GridReducer(state.administrationAccountsRoomsGrid, {type: 'PAGINATE'}), 'filter.uuid', action.dep)
                });
            }
            if (action.id === 'administrationAccountsRoomDocumentsGrid') {
                return Object.assign({}, state, {
                    administrationAccountsRoomDocumentsGrid: set(GridReducer(state.administrationAccountsRoomDocumentsGrid, {type: 'PAGINATE'}), 'filter.uuid', action.uuid)
                });
            }
        case 'GRID_OVERRIDE':
        case 'SHOW_LOADING':
        case 'PAGINATE':
        case 'GRID_RELOAD':
        case 'GRID_FETCH':
            if (action.id === 'administrationAccountsRoomsGrid') {
                return Object.assign({}, state, {
                    administrationAccountsRoomsGrid: GridReducer(state.administrationAccountsRoomsGrid, action)
                });
            }
            if (action.id === 'administrationAccountsRoomDocumentsGrid') {
                return Object.assign({}, state, {
                    administrationAccountsRoomDocumentsGrid: GridReducer(state.administrationAccountsRoomDocumentsGrid, action)
                });
            }
        case 'GRID_RESET':
            if (action.id === 'administrationAccountsRoomDocumentsGrid') {
                const roomDocumentsGrid = GridReducer(state[action.id], action);
                return {
                    ...state,
                    [action.id]: {
                        ...roomDocumentsGrid,
                        filter: {
                            ...roomDocumentsGrid.filter,
                            docType: null
                        }
                    }
                }
            }
        case 'ROOM_TYPES':
            if (action.id === 'administrationAccountsRoom') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        roomTypes: action.items
                    }
                }
            }
        case 'CHECKBOX_SELECTED':
        case 'INPUT_SELECT':
        case 'INPUT_TEXT_CHANGE':
        case 'DATE_SELECTED':
            if (includes([
                'administrationAccountsRoom',
                'administrationAccountsRoomDocument',
            ], action.id)) {
                return set({...state}, `${action.id}.${action.path}`, action.input)
            }
            if (action.id === 'administrationAccountsRoomDocumentsGrid') {
                return {
                    ...state,
                    [action.id]: set(GridReducer(state[action.id], {type: 'PAGINATE'}), action.path, action.input)
                }
            }
        case 'DOCUMENT_RESET':
            if (action.id === 'administrationAccountsRoomDocument') {
                return {
                    ...state,
                    administrationAccountsRoomDocument: {
                        ...state.administrationAccountsRoomDocument,
                        id: null,
                        docType: null,
                        docNum: null,
                        dueDate: null,
                        filePath: null,
                        room: null,
                    }
                }
            }
        case 'FILE_UPLOAD':
            if (['administrationAccountsRoomDocument'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        [action.path]: action.input,
                    },
                };
            }
        case 'ACCOUNT_DOCUMENT_DETAILS':
            if (['administrationAccountsRoomDocument'].includes(action.id)) {
                return {
                    ...state,
                    administrationAccountsRoomDocument: {
                        ...state.administrationAccountsRoomDocument,
                        id: action.data.doc_id,
                        docType: action.data.dty_code,
                        docNum: action.data.doc_num,
                        dueDate: action.data.expiry_date,
                        filePath: action.data,
                        room: action.room_uuid
                    }
                };
            }
        default:
            return state;
    }
}
